<vp-availability-widget-input
	*ngrxLet="isSmallTablet$ as isSmallTablet"
	[className]="className"
	[header]="'global.period-of-stay' | translate"
	[isOpen]="_isOpen"
	[label]="'global.period-of-stay' | translate"
	[placeholder]="'global.choose-dates' | translate"
	[value]="prettyCombinedDates$ | async"
	(emitIsOpen)="popoverStateChanged($event)"
	iconName="icon-calendar"
	inputName="availability-date-range"
>
	<div
		[class.datepicker--hidden]="!_isOpen"
		class="flex flex-col gap-2 card-md"
		data-test-id="availability-date-range"
		id="popover-input-date-range-picker"
	>
		@if (stepperConfig?.useStepper) {
			<div
				class="flex flex-row items-center justify-between gap-3 md:justify-start"
				data-test-id="nights-stepper-wrapper"
			>
				<label
					class="font-semibold text-dark-primary"
					for="night-stepper"
				>
					{{ 'global.number-of-nights' | translate }}
				</label>
				<vp-stepper
					[ariaDecreaseLabel]="'global.decrease-button' | translate"
					[ariaIncreaseLabel]="'global.increase-button' | translate"
					[max]="stepperConfig.max"
					[min]="stepperConfig.min"
					[value]="numberOfNights"
					(valueChange)="onNumberOfNightsChange($event)"
					inputId="night-stepper"
				/>
			</div>
		}
		<vp-calendar
			[blockCalendarJump]="true"
			[calendarData]="filteredCalendarData$ | async"
			[config]="config$ | async"
			[hideRangePrices]="hideRangePrices() || stepperConfig?.useStepper"
			[isLoading]="isLoading"
			[jumpToFirstAvailableDate]="jumpToFirstAvailableDate"
			(datePickerEmitter)="onDatePickerEmitter($event)"
			(dayCreate)="addPricingToDayElement($event)"
			(emitHasError)="onEmitHasError($event)"
			(emitMonthChange)="onEmitMonthChange($event)"
		/>
		@if (showPrices() && false) {
			<span class="text-end text-sm text-dark-tertiary">
				{{ 'components.booking-widget.price-disclosure' | translate }}
			</span>
		}
	</div>
	<div
		class="flex flex-col gap-4"
		data-test-id="availability-date-range-footer"
		widget-input-footer
	>
		<div class="text-center">
			<div class="justify-center text-center">
				<span class="text-sm text-dark-tertiary" data-test-id="summary">
					{{
						(prettyCombinedDates$ | async) || 'global.choose-dates'
							| translate
					}}
				</span>
			</div>
		</div>
		@if (isExternalUrl()) {
			<a
				[attr.aria-disabled]="isCtaDisabled()"
				[attr.href]="bookingtoolHref()"
				[attr.tabindex]="isCtaDisabled() ? -1 : null"
				[class]="
					cn(
						'btn mt-auto w-full btn-primary',
						isCtaDisabled() && 'btn-disabled'
					)
				"
				[target]="openAvailabilityInNewTab() ? '_blank' : '_self'"
				(click)="onSubmitButtonClick($event)"
				data-test-id="date-cta-button"
			>
				{{ 'global.show-availability' | translate }}
			</a>
		} @else {
			<a
				[attr.aria-disabled]="isCtaDisabled()"
				[attr.tabindex]="isCtaDisabled() ? -1 : null"
				[class]="
					cn(
						'btn mt-auto w-full btn-primary',
						isCtaDisabled() && 'btn-disabled'
					)
				"
				[queryParams]="bookingtoolQuery()"
				[queryParamsHandling]="'merge'"
				[routerLink]="isCtaDisabled() ? null : ['./']"
				(click)="onSubmitButtonClick($event)"
				data-test-id="date-cta-button"
			>
				{{ 'global.show-availability' | translate }}
			</a>
		}
		<button
			(click)="onEmitBackButton($event)"
			class="flex items-center gap-1 text-sm text-dark-primary"
			data-test-id="date-back-button"
		>
			<svg-icon
				class="inline-block h-auto w-3"
				src="assets/icons/icon-chevron-left.svg"
			/>
			{{ 'global.back' | translate }}
		</button>
	</div>
</vp-availability-widget-input>
